module.exports = __webpack_public_path__ + "images/directory/featured-hero/planyway.4263346e4ecd365705b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/directory/featured-hero/planyway.jpg
// module id = aN2r
// module chunks = 0